"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIATALocations = getIATALocations;
var _CountryFlag = _interopRequireDefault(require("@kiwicom/orbit-components/lib/CountryFlag"));
var _config = _interopRequireDefault(require("../../../../../consts/config"));
var _jsxRuntime = require("react/jsx-runtime");
function sanitizeApiResponse(location) {
  var _sanitizeLocationArea, _sanitizeLocationArea2;
  const city = sanitizeLocationArea(location.city);
  const country = location.type === "airport" || location.type === "station" ? ((_sanitizeLocationArea = sanitizeLocationArea(location.city.country)) === null || _sanitizeLocationArea === void 0 ? void 0 : _sanitizeLocationArea.locationId) || "anywhere" : ((_sanitizeLocationArea2 = sanitizeLocationArea(location.country)) === null || _sanitizeLocationArea2 === void 0 ? void 0 : _sanitizeLocationArea2.locationId) || "anywhere";
  return {
    title: `${String(city === null || city === void 0 ? void 0 : city.name)} (${String(location.id)})`,
    value: location.id,
    prefix: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CountryFlag.default, {
      code: country.toLowerCase(),
      name: "",
      role: "presentation"
    })
  };
}
function sanitizeLocationArea(area) {
  return area ? {
    locationId: area.id,
    name: area.name
  } : null;
}
async function getIATALocations(value) {
  var _response$locations;
  let locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "en-US";
  const response = await fetch(`${_config.default.apiLocations}?term=${value}&locale=${locale}&location_types=airport`).then(res => res.json());
  const sanitizedResponse = (_response$locations = response.locations) === null || _response$locations === void 0 ? void 0 : _response$locations.map(location => sanitizeApiResponse(location));
  return sanitizedResponse;
}